<template>
  <div class="container mx-auto lg:my-12 md:my-12">
    <div
      class="bg-efe8f9 md:rounded-3xl lg:rounded-3xl rounded-xl md:p-8 lg:p-8 p-4 shadow-b-2xl relative"
    >
      <div>
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
            <div
              class="pt-6 grid md:grid-cols-3 lg:grid-cols-3 grid-cols-1 gap-x-5 md:gap-y-6 lg:gap-y-6"
            >
              <div class="">
                <p class="input-title text-primary">Name</p>
                <base-input
                  v-model="name"
                  placeholder="Enter your name"
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Name"
                  :rules="{ required: true, alpha_spaces: true }"
                ></base-input>
              </div>

              <div class="">
                <p class="input-title text-primary">Email Address</p>
                <base-input
                  v-model="email"
                  placeholder="Enter your Email ID"
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Email"
                  :rules="{ required: true, email: true }"
                ></base-input>
              </div>

              <div class="">
                <p class="input-title text-primary">Mobile No.</p>
                <base-input
                  v-model="mobile"
                  placeholder="Enter your Mobile No."
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Mobile No."
                  :rules="{
                    required: true,
                    numeric: true,
                    min: 10,
                    max: 10,
                  }"
                ></base-input>
              </div>
            </div>

            <div class="md:mb-0 lg:mb-0 mb-14">
              <p class="input-title text-primary">Query</p>
              <b-form-textarea
                v-model="message"
                placeholder="Enter Query"
                rows="5"
                class="md:border-0 lg:border-0 custipshadow"
              ></b-form-textarea>
            </div>
            <!-- <vue-recaptcha
                      sitekey="6LfZLWkeAAAAALwhHWrc9kPpHsS3KOGzMZNXXNW6"
                      :loadRecaptchaScript="true"
                      ref="recaptcha"
                    > -->

            <div class="mt-8">
              <b-button
                type="submit"
                variant="primary"
                :disabled="isdisabled"
                class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold flex m-auto"
                >Send Query</b-button
              >
            </div>
            <!-- </vue-recaptcha>  -->
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import FileUploader from "@/components/FileUploader.vue";
export default {
  // components: {
  //   FileUploader,
  // },

  data() {
    return {
      message: "",
      name: "",
      email: "",
      mobile: "",
    };
  },
  computed: {
    isdisabled() {
      if (
        this.message.trim() === "" ||
        this.name.trim() === "" ||
        this.email.trim() === "" ||
        this.mobile.trim() === ""
      ) {
        return true;
      }
      return false;
    },
    ...mapState("auth", { user: "user" }),
  },
  methods: {
    async onSubmit() {
      // console.log("emailContactUs");

      let payload = {
        name: this.name,
        email: this.email,
        mobile: this.mobile,
        message: this.message,
      };

      let loader = this.$loading();

      try {
        const contactUs = await this.$store.dispatch(
          "hoc/emailContactUs",
          payload
        );
        if (contactUs.code == 200) {
          // this.$router.push({ name: "blogs" });
          this.$swal.fire({
            text: "Your Query Submitted Successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.resetForm();
        }

        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    resetForm() {
      this.name = "";
      this.email = "";
      this.mobile = "";
      this.message = "";
    },
  },
  mounted() {
    if (!!Object.keys(this.user).length) {
      this.email = this.user.email;
      this.name = `${this.user.firstname} ${this.user.lastname}`;
      this.mobile = String(this.user.mobile);
    }
  },
};
</script>
